<template>
  <div>
    <div class="card" id="detail-command">
      <detail-commande :commande="commande"
        :commandeDetail="commandeDetail"
        :isEditPrevisu="isEditPrevisu"
        :isPrevisualisation="isPrevisualisation"
        :isEdit="isEdit"
        @masqueRemiseChange="$emit('masqueRemiseChange', $event)"
        @masqueLigneChange="$emit('masqueLigneChange', $event)">
      </detail-commande>
    </div>
    <echeancier-facturation class="mgt-20px"
      :dcf="commandeDetail"
      isFromBail/>
    <div class="card mgt-20px" id="attachments" v-if="!isEdit">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes :checkPermissions=checkPermissions(constantes.COMMANDE_ACHAT.maj)
          readOnly
          deletable
          autoSave/>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import echeancierFacturation from '@/components/devisCommandes/detailDevisCommande/echeancierFacturation';
import PiecesJointes from '@/components/general/piecesJointes';
import { COMMANDE_ACHAT } from '@/configuration/baux/permissionsBauxConf';
import detailCommande from '@/components/baux/commandeAchat/detail/detailCommande';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
    commandeDetail: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
    },
    isPrevisualisation: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        COMMANDE_ACHAT,
      },
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    echeancierFacturation,
    detailCommande,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>
